/* Auto light/dark header + product colour rail. */
(function () {
  var header = document.querySelector('.header');
  if (!header) return;
  var THRESHOLD = 0.62;
  var decoded = {};
  var lumCache = {};

  (function injectCss() {
    if (document.getElementById('header-tone-css')) return;
    var s = document.createElement('style');
    s.id = 'header-tone-css';
    s.textContent =
      '.header[data-tone="dark"],.header[data-tone="dark"] a,.header[data-tone="dark"] button,' +
      '.header[data-tone="dark"] select,.header[data-tone="dark"] span{color:var(--header-transparent-text,#fff)!important}' +
      '.header[data-tone="dark"] svg{stroke:currentColor}' +
      '.header[data-tone="light"],.header[data-tone="light"] a,.header[data-tone="light"] button,' +
      '.header[data-tone="light"] select,.header[data-tone="light"] span{color:var(--ink,#0b0b0a)}' +
      '.header__logo{transition:opacity .2s ease,filter .2s ease}';
    (document.head || document.documentElement).appendChild(s);
  })();

  function lum(r, g, b) { return (0.2126 * r + 0.7152 * g + 0.0722 * b) / 255; }

  function parse(c) {
    var m = (c || '').match(/rgba?\(([^)]+)\)/);
    if (!m) return null;
    var p = m[1].split(/[,\s\/]+/).filter(function (s) { return s !== ''; }).map(parseFloat);
    if (p.length < 3 || isNaN(p[0])) return null;
    return { r: p[0], g: p[1], b: p[2], a: p.length > 3 && !isNaN(p[3]) ? p[3] : 1 };
  }

  function getImage(src) {
    if (src in decoded) return decoded[src] === 'pending' ? null : decoded[src];
    decoded[src] = 'pending';
    var i = new Image();
    i.crossOrigin = 'anonymous';
    i.onload = function () { decoded[src] = i; update(); };
    i.onerror = function () { decoded[src] = null; };
    i.src = src;
    return null;
  }

  function stripLum(src, t0, t1, xFrac) {
    var key = src + '|' + Math.round(t0 * 20) + '|' + Math.round(t1 * 20) + '|' + Math.round(xFrac * 4);
    if (key in lumCache) return lumCache[key];
    var im = getImage(src);
    if (!im) return null;
    var N = 64, out = null;
    try {
      var c = document.createElement('canvas');
      c.width = N; c.height = N;
      var x = c.getContext('2d');
      x.drawImage(im, 0, 0, N, N);
      var y0 = Math.max(0, Math.floor(t0 * N));
      var y1 = Math.min(N, Math.max(y0 + 1, Math.ceil(t1 * N)));
      var x0 = Math.max(0, Math.floor((xFrac - 0.2) * N));
      var x1 = Math.min(N, Math.max(x0 + 1, Math.ceil((xFrac + 0.2) * N)));
      var d = x.getImageData(x0, y0, x1 - x0, y1 - y0).data, t = 0, n = 0;
      for (var k = 0; k < d.length; k += 4) { t += lum(d[k], d[k + 1], d[k + 2]); n++; }
      out = n ? t / n : null;
    } catch (e) { out = 0.35; }
    lumCache[key] = out;
    return out;
  }

  function bandFractions(rect, band) {
    if (!rect.height) return null;
    var t0 = Math.max(0, Math.min(1, (band.top - rect.top) / rect.height));
    var t1 = Math.max(0, Math.min(1, (band.bottom - rect.top) / rect.height));
    if (t1 - t0 < 0.02) { t0 = 0; t1 = 0.12; }
    return [t0, t1];
  }

  function behindAt(x, y, band) {
    var els = document.elementsFromPoint(x, y) || [];
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el === header || header.contains(el)) continue;
      if (el.hasAttribute && el.hasAttribute('data-header-tone')) {
        return el.getAttribute('data-header-tone') === 'dark' ? 0 : 1;
      }
      var r = el.getBoundingClientRect();
      var f = bandFractions(r, band);
      var xf = r.width ? (x - r.left) / r.width : 0.5;
      if (el.tagName === 'IMG') {
        var src = el.currentSrc || el.src;
        return src && f ? stripLum(src, f[0], f[1], xf) : null;
      }
      if (el.tagName === 'VIDEO') return 0.3;
      var cs = getComputedStyle(el);
      if (cs.backgroundImage && cs.backgroundImage !== 'none') {
        var u = cs.backgroundImage.match(/url\(["']?([^"')]+)/);
        if (u && f) return stripLum(u[1], f[0], f[1], xf);
        return 0.3;
      }
      var bg = parse(cs.backgroundColor);
      if (bg && bg.a >= 0.5) return lum(bg.r, bg.g, bg.b);
    }
    return null;
  }

  function toneAt() {
    var r = header.getBoundingClientRect();
    if (r.bottom <= 0) return null;
    var hb = parse(getComputedStyle(header).backgroundColor) || { r: 255, g: 255, b: 255, a: 0 };
    var ha = Math.max(0, Math.min(1, hb.a));
    var hl = lum(hb.r, hb.g, hb.b);
    if (ha >= 0.97) return hl < THRESHOLD ? 'dark' : 'light';

    var band = { top: r.top, bottom: r.bottom };
    var y = Math.max(1, Math.min(window.innerHeight - 2, r.top + r.height / 2));
    var xs = [0.5, 0.15, 0.85, 0.32, 0.68].map(function (f) { return window.innerWidth * f; });
    var vals = [];
    for (var i = 0; i < xs.length; i++) {
      var v = behindAt(xs[i], y, band);
      if (v != null) vals.push(v);
    }
    if (!vals.length) return hl < THRESHOLD ? 'dark' : 'light';
    var avg = vals.reduce(function (a, b) { return a + b; }, 0) / vals.length;
    var blended = ha * hl + (1 - ha) * avg;
    return blended < THRESHOLD ? 'dark' : 'light';
  }

  var raf = null, last = null;
  /* Perf fix: toneAt() calls document.elementsFromPoint() (forces a layout
     flush) up to 5x, plus canvas getImageData readback on cache misses. That
     was previously run on every rAF tick during scroll (as often as every
     frame). A header only needs to flip light/dark a handful of times per
     scroll gesture, not 60x/sec, so this now skips recomputation for 80ms
     after each real check — scroll still feels perfectly responsive (the
     header's own color transition is CSS-animated over .2s anyway) but the
     expensive DOM/canvas work runs far less often. */
  var lastRun = 0;
  var MIN_INTERVAL = 80;

  function applyLogos(tone) {
    var brand = header.querySelector('.header__brand');
    if (!brand) return;
    var logos = [].slice.call(brand.querySelectorAll('.header__logo'));
    if (!logos.length) return;
    var inverse = brand.querySelector('.header__logo--inverse');
    var mobile = brand.querySelector('.header__logo--mobile');
    var solid = logos.filter(function (el) { return el !== inverse && el !== mobile; })[0];
    var isMobile = window.innerWidth <= 749;
    var base = (isMobile && mobile) || solid || logos[0];
    var target = tone === 'dark' ? (inverse || base) : base;
    logos.forEach(function (el) {
      el.style.setProperty('display', el === target ? 'block' : 'none', 'important');
      if (tone === 'dark' && el === target && el !== inverse) {
        el.style.setProperty('filter', 'brightness(0) invert(1)', 'important');
      } else {
        el.style.removeProperty('filter');
      }
    });
  }

  function update(force) {
    var now = Date.now ? Date.now() : new Date().getTime();
    if (!force && now - lastRun < MIN_INTERVAL) return;
    lastRun = now;
    var t = toneAt();
    if (t && t !== last) { last = t; header.setAttribute('data-tone', t); }
    if (t) applyLogos(t);
  }
  function onScroll() {
    if (raf) return;
    raf = requestAnimationFrame(function () { raf = null; update(); });
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  window.addEventListener('load', function () { update(true); });
  document.addEventListener('shopify:section:load', function () { update(true); });
  document.addEventListener('shopify:section:select', function () { update(true); });
  document.addEventListener('DOMContentLoaded', function () { update(true); });
  update(true);
  setTimeout(function () { update(true); }, 300);
  setTimeout(function () { update(true); }, 1200);
})();

/* Product colour rail: turns the colour-family thumbnails into a slider with a scroll
   indicator and a More colours dropdown (only shown with more than 6 colours). */
(function () {
  function init() {
    var info = document.querySelector('.pdp__inner');
    if (!info || info.hasAttribute('data-crail-done')) return;
    var links = [].slice.call(info.querySelectorAll('a[aria-current]')).filter(function (a) { return a.querySelector('img'); });
    if (links.length < 2) return;
    var rail = links[0].parentElement;
    var wrap = rail && rail.parentElement;
    if (!rail || !wrap) return;
    info.setAttribute('data-crail-done', '');

    var css = document.createElement('style');
    css.textContent =
      '.crail{overflow-x:auto;flex-wrap:nowrap!important;scroll-snap-type:x proximity;scrollbar-width:none;-ms-overflow-style:none}' +
      '.crail::-webkit-scrollbar{display:none}' +
      '.crail>a{flex:0 0 auto;scroll-snap-align:start;transition:border-color .18s ease,opacity .18s ease}' +
      '.crail>a:hover{opacity:.86}' +
      '.crail-bar{position:relative;height:1px;background:var(--line,#e4ded3);margin-top:11px}' +
      '.crail-bar>span{position:absolute;left:0;top:-1px;height:3px;background:var(--ink,#0b0b0a);transition:transform .1s linear,width .1s linear}' +
      '.crail-top{display:flex;justify-content:space-between;align-items:baseline;gap:12px}' +
      '.crail-more{position:relative}' +
      '.crail-more>summary{list-style:none;cursor:pointer;font:400 9.5px/1 var(--mono,ui-monospace,Menlo,monospace);letter-spacing:.16em;text-transform:uppercase;border-bottom:1px solid currentColor;padding-bottom:3px;white-space:nowrap}' +
      '.crail-more>summary::-webkit-details-marker{display:none}' +
      '.crail-panel{position:absolute;right:0;top:calc(100% + 10px);z-index:30;background:var(--bg,#fff);border:var(--border,1px) solid var(--line,#e4ded3);min-width:230px;max-height:290px;overflow:auto;padding:5px 0;box-shadow:0 20px 44px rgba(0,0,0,.10)}' +
      '.crail-panel a{display:flex;gap:11px;align-items:center;padding:9px 14px;font:400 10.5px/1.2 var(--mono,ui-monospace,Menlo,monospace);letter-spacing:.06em;text-transform:uppercase;text-decoration:none;color:inherit}' +
      '.crail-panel a:hover{background:var(--paper,#f4f0e9)}' +
      '.crail-panel a[data-current]{opacity:.45}' +
      '.crail-panel i{width:17px;height:21px;flex:0 0 auto;background-size:cover;background-position:center;border:var(--border,1px) solid var(--line,#e4ded3)}' +
      '@media (max-width:860px){.pdp__thumbs{padding:0 var(--gutter,18px);background:transparent;gap:6px}}';
    document.head.appendChild(css);

    rail.classList.add('crail');

    var label = wrap.querySelector('.label');
    var top = document.createElement('div');
    top.className = 'crail-top';
    wrap.insertBefore(top, rail);
    if (label) top.appendChild(label);

    if (links.length > 6) {
      var det = document.createElement('details');
      det.className = 'crail-more';
      var sum = document.createElement('summary');
      sum.textContent = 'More colours';
      det.appendChild(sum);
      var panel = document.createElement('div');
      panel.className = 'crail-panel';
      links.forEach(function (a) {
        var img = a.querySelector('img');
        var row = document.createElement('a');
        row.href = a.getAttribute('href');
        if (a.getAttribute('aria-current') === 'true') row.setAttribute('data-current', '');
        var sw = document.createElement('i');
        if (img) sw.style.backgroundImage = 'url(' + (img.currentSrc || img.src) + ')';
        var name = document.createElement('span');
        name.textContent = a.getAttribute('title') || (img && img.alt) || 'Colour';
        row.appendChild(sw);
        row.appendChild(name);
        panel.appendChild(row);
      });
      det.appendChild(panel);
      top.appendChild(det);
      document.addEventListener('click', function (e) {
        if (det.hasAttribute('open') && !det.contains(e.target)) det.removeAttribute('open');
      });
    }

    var barWrap = document.createElement('div');
    barWrap.className = 'crail-bar';
    var bar = document.createElement('span');
    barWrap.appendChild(bar);
    rail.insertAdjacentElement('afterend', barWrap);

    function sync() {
      var max = rail.scrollWidth - rail.clientWidth;
      if (max < 4) { barWrap.style.display = 'none'; return; }
      barWrap.style.display = '';
      var ratio = rail.clientWidth / rail.scrollWidth;
      var w = Math.max(12, ratio * 100);
      bar.style.width = w + '%';
      bar.style.transform = 'translateX(' + ((rail.scrollLeft / max) * (100 - w) / w * 100) + '%)';
    }
    rail.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    var active = links.filter(function (a) { return a.getAttribute('aria-current') === 'true'; })[0];
    if (active) rail.scrollLeft = Math.max(0, active.offsetLeft - rail.clientWidth / 2 + active.offsetWidth / 2);
    sync();
    setTimeout(sync, 400);
  }
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('load', init);
  init();
})();
